import SectionHeading from "@/pages/home/components/SectionHeading";
import { safetyTips } from "@/mocks/home";

export default function SafetySection() {
  return (
    <section
      id="safety"
      className="scroll-mt-28 py-14 md:py-20 bg-background-100 border-y border-background-200"
    >
      <div className="px-4 md:px-6">
        <SectionHeading
          eyebrow="安全提示"
          title="访问前请先看这几条"
          desc="网络上存在不少仿冒页面，掌握下面几点可以帮你快速分辨，保护账号与设备安全。"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {safetyTips.map((tip) => (
            <div
              key={tip.id}
              className="flex gap-4 p-5 rounded-lg bg-background-50 border border-background-200"
            >
              <span className="w-11 h-11 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center shrink-0">
                <i className={`${tip.icon} text-xl`} aria-hidden="true" />
              </span>
              <div className="min-w-0">
                <h3 className="font-heading font-bold text-base text-foreground-950">{tip.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{tip.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 p-5 md:p-6 rounded-lg bg-primary-950 text-background-100 flex flex-col md:flex-row md:items-center gap-4">
          <span className="w-12 h-12 rounded-md bg-primary-500 text-background-50 flex items-center justify-center shrink-0">
            <i className="ri-global-line text-2xl" aria-hidden="true" />
          </span>
          <div className="flex-1">
            <h3 className="font-heading font-bold text-base text-background-50">只认准本页整理的入口</h3>
            <p className="mt-1.5 text-sm text-background-100/80 leading-relaxed">
              把本页加入收藏，以后从收藏夹进入即可，无需在搜索结果中反复辨认真假链接。
            </p>
          </div>
          <a
            href="#top"
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md bg-background-50 text-primary-800 text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-up-line" aria-hidden="true" />
            回到页面顶部
          </a>
        </div>
      </div>
    </section>
  );
}